import { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community';
import { ComparableCell } from 'src/components/molecules/ComparableCell/ComparableCell';

export const renderMonthCell = (params: ICellRendererParams, column: ColDef) => {
    if (params.node.group) {
        const [_, month] = (column.field ?? '').split('.');
        const value = params.node.aggData[month];

        if (value === null || value === undefined) return;
        const valueToUse = Array.isArray(value) ? value : [value, undefined];
        const isSameValue = valueToUse[0] === valueToUse[1];

        const formattedValue = isSameValue ? [valueToUse[0], undefined] : valueToUse;

        return typeof params.colDef?.valueFormatter === 'function' ? (
            params.colDef.valueFormatter({
                ...params,
                value: <ComparableCell {...params} value={formattedValue} />,
            } as ValueFormatterParams)
        ) : (
            <ComparableCell {...params} value={formattedValue} />
        );
    }
    return <ComparableCell {...params} />;
};
